import { SEARCH_FILTER } from '../constants';
const getSearchFilter = pageBuilder => {
  const searchFilter = [];
  const checkForSearchFilter = pbItems => {
    pbItems.forEach(pbItem => {
      if (pbItem.type === SEARCH_FILTER) searchFilter.push(pbItem);
      if (pbItem.items && pbItem.items.length) checkForSearchFilter(pbItem.items);
    });
  };
  checkForSearchFilter(pageBuilder);
  return searchFilter;
};
export default getSearchFilter;
//# sourceMappingURL=get-search-filter.js.map